exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bind-channel .tip-dot[data-v-eae70484]{display:inline-block;width:4px;height:4px;background:#ff6900;border-radius:50%;margin-bottom:2px;margin-right:4px}.bind-channel .flex[data-v-eae70484]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.bind-channel .tips[data-v-eae70484]{margin-top:-10px}", ""]);

// exports
